const styles = {
    profileButton: {
        background: '#3876AA',
        borderRadius: '16px',
        width: '598px',
        height: '48px',
        textTransform: 'none',
        ml: 3,
    },
    profileField: {
        marginTop: '24px',
    },
    warning: {
        fontFamily: 'Silka_Regular',
        fontSize: '14px',
        lineHeight: '21px',
        color: '#5C697B',
        fontWeight: 400,
        ml: 3,
        mb: 5,
    },
    error_message: {
        marginTop: '24px',
        color: '#ED0000',
        fontFamily: 'Silka_Regular',
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '21px',
        ml: 3,
        mb: 1,
    },
};
export default styles;
